import React from 'react'
import dayjs from 'dayjs'
import DateFormat from '../../store/types/enums/DateFormat'
import parseJsonSafe from './parseJsonSafe'
import ExpandableHistoryRow from './ExpandableHistoryRow'
import { Dayjs } from 'dayjs'
import { History } from '../../store/redux/reducers/auditSlice'

interface FilteredHistoryRowsProps {
  filteredAuditData: History[]
  date: string
  selectedDate: Dayjs
}

const FilteredHistoryRows: React.FC<FilteredHistoryRowsProps> = ({ filteredAuditData, date, selectedDate }) => {
  return (
    <>
      {filteredAuditData
        .filter(filteredItem => dayjs(filteredItem.createdAt).format(DateFormat.DayTwoMonthNameYear) === date)
        .sort((a, b) => dayjs(b.createdAt).diff(dayjs(a.createdAt)))
        .map((filteredItem, idx) => {
          const oldDates = parseJsonSafe(filteredItem.oldValue)
          const newDates = parseJsonSafe(filteredItem.newValue)
          const startTime = oldDates.start_time || newDates.start_time

          if (!startTime) return null

          if (dayjs(selectedDate).isSame(dayjs(startTime), 'month')) {
            return <ExpandableHistoryRow data={filteredItem} key={idx} />
          }

          return null
        })}
    </>
  )
}

export default FilteredHistoryRows